// Edit all website text, packages, photos, films and reviews here.

export const BRAND = {
  name: "Glow Motion Pictures",
  tagline: "Capturing Precious Moments Since 1990",
  heroLine: "We Capture Every Emotions",
  mission:
    "Our goal is not just photography, but to beautifully capture your emotions, love, and special moments, so you can relive them for a lifetime.",
  about:
    "With 30+ years of experience, Glow Motion Pictures is known for capturing real emotions, traditions, and unforgettable wedding moments with perfection. 300+ weddings successfully covered, delivering quality and trust to every client.",
  contactPerson: "Kishan Patel",
  phone: "+91 8128581106",
  phoneHref: "tel:+918128581106",
  whatsapp: "https://wa.me/918128581106?text=Hello%20Glow%20Motion%20Pictures%2C%20I%27d%20like%20to%20enquire%20about%20a%20booking.",
  instagram: "@glow_motion_pictures",
  instagramUrl: "https://www.instagram.com/glow_motion_pictures/",
  email: "glowmotionpictures16@gmail.com",
  location: "Junagadh / Ahmedabad, Gujarat, India",
  mapEmbed: "https://maps.google.com/maps?q=Junagadh%2C%20Gujarat&z=12&output=embed",
};

export const NAV = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "packages", label: "Packages" },
  { id: "portfolio", label: "Portfolio" },
  { id: "films", label: "Films" },
  { id: "reviews", label: "Reviews" },
  { id: "terms", label: "Terms" },
  { id: "contact", label: "Contact" },
];

export const STATS = [
  { value: 30, suffix: "+", label: "Years of experience" },
  { value: 300, suffix: "+", label: "Weddings covered" },
];

export const TEAM = ["Traditional Photographers", "Candid Photographers", "Traditional Videographers", "Cinematic Videographers", "Drone Operators"];

export const MARQUEE = ["Weddings", "Engagements", "Pre-Wedding Films", "Same Day Stories", "Cinematic Highlights", "Candid Portraits", "Reels", "Drone Coverage"];

export const SERVICES = [
  {
    id: "wedding",
    icon: "heart",
    title: "Wedding",
    image: "/images/w3.jpg",
    text: "Every ritual, every glance, every tear of joy, documented with traditional and cinematic coverage from the first haldi to the final vidaai.",
    points: ["Traditional & candid photography", "Cinematic highlight & full movie", "Same day story & reels"],
  },
  {
    id: "engagement",
    icon: "gem",
    title: "Engagement",
    image: "/images/e3.jpg",
    text: "The ring, the promise, the families coming together. We capture the quiet nerves and the loud celebrations of your engagement day.",
    points: ["Ring ceremony coverage", "Couple portraits edited", "Highlight film & reels"],
  },
  {
    id: "prewedding",
    icon: "camera",
    title: "Pre-Wedding",
    image: "/images/p2.jpg",
    text: "A story written just for the two of you. Styled one or two day shoots with edited photos, reels and a full pre-wedding song.",
    points: ["One day or two day shoots", "10 Days To Go photos", "Pre-wedding song film"],
  },
];

const WEDDING_BASE = ["Wedding all photos on Pendrive", "Same Day Story (Wedding Couple)", "Couple photos edited", "All raw data", "Highlight 4/5 min", "3 Reels", "Full Movie"];
const ENGAGEMENT_BASE = ["Engagement all photos on Pendrive", "Same Day Story (Engagement Couple)", "Couple photos edited", "All raw data", "Highlight 2/3 min", "2 Reels", "Full Movie"];

export const PACKAGE_GROUPS = [
  {
    id: "wedding",
    label: "Wedding",
    title: "Wedding Package 2026",
    tiers: [
      { key: "wedding-silver", tier: "Silver", price: 60000, crew: ["Traditional Photographer", "Traditional Videographer"], features: WEDDING_BASE },
      { key: "wedding-gold", tier: "Gold", price: 85000, popular: true, crew: ["Traditional Photographer", "Traditional Videographer", "Candid Photographer"], features: WEDDING_BASE },
      {
        key: "wedding-platinum",
        tier: "Platinum",
        price: 130000,
        crew: ["Traditional Photographer", "Traditional Videographer", "Candid Photographer", "Cinematic Videographer", "Drone"],
        features: ["Wedding all photos on Pendrive", "Instagram Post (Wedding Couple)", "Same Day Story (Wedding Couple)", "Couple photos edited", "All raw data", "Cinematic Teaser", "Cinematic Highlight 5/6 min", "5 Reels", "Full Movie"],
      },
    ],
  },
  {
    id: "engagement",
    label: "Engagement",
    title: "Engagement Package 2026",
    tiers: [
      { key: "engagement-silver", tier: "Silver", price: 25000, crew: ["Traditional Photographer", "Traditional Videographer"], features: ENGAGEMENT_BASE },
      { key: "engagement-gold", tier: "Gold", price: 35000, popular: true, crew: ["Traditional Photographer", "Traditional Videographer", "Candid Photographer"], features: ENGAGEMENT_BASE },
      {
        key: "engagement-platinum",
        tier: "Platinum",
        price: 55000,
        crew: ["Traditional Photographer", "Traditional Videographer", "Candid Photographer", "Cinematic Videographer"],
        features: ["Engagement all photos on Pendrive", "Instagram Post (Engagement Couple)", "Same Day Story (Engagement Couple)", "Couple photos edited", "All raw data", "Cinematic Teaser", "Cinematic Highlight 5/6 min", "4 Reels", "Full Movie"],
      },
    ],
  },
];

export const PREWEDDING = {
  id: "prewedding",
  label: "Pre-Wedding",
  title: "Pre-Wedding Package 2026",
  plans: [
    {
      key: "prewedding-oneday",
      name: "One Day",
      options: [
        { key: "prewedding-oneday-photo", label: "Photography", price: 20000, detail: "50+ edited photos & all soft copy, 10 Days To Go photos" },
        { key: "prewedding-oneday-video", label: "Videography", price: 25000, detail: "2 Reels & 1 full edit song" },
      ],
    },
    {
      key: "prewedding-twoday",
      name: "Two Day",
      options: [
        { key: "prewedding-twoday-photo", label: "Photography", price: 30000, detail: "50+ edited photos & all soft copy, 10 Days To Go photos" },
        { key: "prewedding-twoday-video", label: "Videography", price: 38000, detail: "4 Reels & 1 full edit song" },
      ],
    },
  ],
  outputs: ["Pre-wedding all photos on hard drive", "Instagram Post", "Reels", "10 Days To Go", "Pre-Wedding Song"],
  extras: ["Stay", "Travel", "Food", "Beautician", "Costume"],
};

export const EVENT_TYPES = ["Wedding", "Engagement", "Pre-Wedding", "Other"];

export const BOOKING_PACKAGES = [
  ...PACKAGE_GROUPS.flatMap((g) => g.tiers.map((t) => `${g.label} – ${t.tier}`)),
  ...PREWEDDING.plans.map((p) => `Pre-Wedding – ${p.name}`),
  "Not sure yet / Custom",
];

// Placeholder photos. Upload your own from the admin dashboard (/admin).
export const GALLERY_CATEGORIES = [
  { id: "all", label: "All" },
  { id: "wedding", label: "Wedding" },
  { id: "engagement", label: "Engagement" },
  { id: "prewedding", label: "Pre-Wedding" },
];

export const SAMPLE_GALLERY = [
  { id: "s1", src: "/images/w2.jpg", category: "wedding", caption: "Wedding portraits" },
  { id: "s2", src: "/images/e1.jpg", category: "engagement", caption: "The ring moment" },
  { id: "s3", src: "/images/p1.jpg", category: "prewedding", caption: "Through the lens" },
  { id: "s4", src: "/images/w5.jpg", category: "wedding", caption: "Varmala" },
  { id: "s5", src: "/images/p4.jpg", category: "prewedding", caption: "Sea breeze" },
  { id: "s6", src: "/images/w6.jpg", category: "wedding", caption: "Mehendi hands" },
  { id: "s7", src: "/images/e2.jpg", category: "engagement", caption: "Promise" },
  { id: "s8", src: "/images/p3.jpg", category: "prewedding", caption: "Veil in the wind" },
  { id: "s9", src: "/images/w4.jpg", category: "wedding", caption: "Rituals" },
  { id: "s10", src: "/images/e3.jpg", category: "engagement", caption: "Rings, Gujarat" },
  { id: "s11", src: "/images/p5.jpg", category: "prewedding", caption: "Hills" },
  { id: "s12", src: "/images/w3.jpg", category: "wedding", caption: "The bride" },
  { id: "s13", src: "/images/e4.jpg", category: "engagement", caption: "Yes" },
  { id: "s14", src: "/images/p7.jpg", category: "prewedding", caption: "Royal story" },
];

// Add a YouTube video id (the part after watch?v=) or an Instagram reel link to each film.
export const FILMS = [
  { id: "f1", title: "Savan & Dhruvi", subtitle: "Instagram reel", youtubeId: "", instagramUrl: "https://www.instagram.com/reel/DZ-k426ywXp/?vrfl=MWMxaHhpcWwwNTVvYQ==", poster: "/images/w5.jpg", format: "wide" },
  { id: "f2", title: "Engagement Reel", subtitle: "Instagram reel", youtubeId: "", instagramUrl: "", poster: "/images/e2.jpg", format: "tall" },
  { id: "f3", title: "Pre-Wedding Song", subtitle: "Full edit song", youtubeId: "", instagramUrl: "", poster: "/images/p5.jpg", format: "tall" },
];

// Sample reviews: replace with real words from your couples.
export const TESTIMONIALS = [
  { name: "Riya & Harsh", event: "Wedding · Junagadh", text: "Every single ritual was captured so beautifully. When we watched our full movie, the whole family cried again. Kishanbhai's team made us feel completely at ease." },
  { name: "Nidhi & Parth", event: "Engagement · Ahmedabad", text: "The candid photos are pure magic. They caught moments we didn't even know happened. Our same day story was ready before the party ended!" },
  { name: "Krupa & Dhaval", event: "Pre-Wedding · Gir", text: "Our two day pre-wedding shoot felt like a film set and a holiday together. The song edit is something we will treasure forever." },
];

export const TERMS = [
  { title: "Payment Terms", text: "30% advance to confirm booking, 40% on the event day, remaining 30% before final delivery." },
  { title: "Cancellation Policy", text: "Advance payment is non-refundable in case of cancellation. Date change is subject to availability." },
  { title: "Data Safety", text: "We take utmost care of your data; however, in case of unforeseen technical issues, natural calamities, or data loss beyond our control, Glow Motion Pictures will not be held responsible." },
  { title: "Traveling & Accommodation", text: "Traveling charges are extra for outstation events. Accommodation & food must be provided by the client for the team (if required)." },
  { title: "Creative Rights", text: "Glow Motion Pictures reserves the right to use selected photos/videos for portfolio, social media, and promotional purposes." },
  { title: "Final Delivery", text: "Final output will be shared via Pen Drive / Online Drive." },
];
